import { useState, useCallback } from "react";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Ribbon from "@/components/site/Marquee";
import Gallery from "@/components/site/Gallery";
import Packages from "@/components/site/Packages";
import Trust from "@/components/site/Trust";
import Reviews from "@/components/site/Reviews";
import Faq from "@/components/site/Faq";
import { Referral, Footer } from "@/components/site/Referral";
import Booking from "@/components/site/Booking";
import "@/App.css";

function App() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [prefill, setPrefill] = useState(null);

  const openBooking = useCallback((opts) => {
    setPrefill(opts && typeof opts === "object" && !opts.nativeEvent ? { ...opts, _t: Date.now() } : { _t: Date.now() });
    setBookingOpen(true);
  }, []);

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App min-h-screen bg-cream">
        <Nav onBook={() => openBooking()} />
        <main>
          <Hero onBook={() => openBooking()} />
          <Ribbon />
          <Gallery />
          <Packages onBook={openBooking} />
          <Trust />
          <Reviews />
          <Faq />
          <Referral />
        </main>
        <Footer />
        <Booking open={bookingOpen} onClose={() => setBookingOpen(false)} prefill={prefill} />

        {/* Sticky mobile book bar */}
        <button
          data-testid="sticky-book-btn"
          onClick={() => openBooking()}
          className="fixed bottom-5 left-1/2 z-40 -translate-x-1/2 rounded-full bg-ink px-8 py-4 text-sm font-bold uppercase tracking-widest text-cream shadow-lg shadow-ink/20 transition-transform active:scale-95 sm:hidden"
        >
          Book Appointment
        </button>

        <Toaster position="top-center" />
      </div>
    </ReactLenis>
  );
}

export default App;
